import { render, staticRenderFns } from "./VoteDetail.vue?vue&type=template&id=43311852&scoped=true&"
import script from "./VoteDetail.vue?vue&type=script&lang=ts&"
export * from "./VoteDetail.vue?vue&type=script&lang=ts&"
import style0 from "./VoteDetail.vue?vue&type=style&index=0&id=43311852&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43311852",
  null
  
)

export default component.exports